import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import { cn } from '@/lib/utils'
import Reveal from '@/components/landing/reveal'
import Lightbox from '@/components/landing/lightbox'
import MemoryPhoto from '@/components/landing/memory-photo'
import SectionHeading from '@/components/landing/section-heading'
import { GALLERY } from '@/constants/birthday'

const TILTS = ['-rotate-2', 'rotate-1', '-rotate-1', 'rotate-2', '-rotate-2', 'rotate-1', '-rotate-1']

const GallerySection: FC = (): ReactNode => {
    const [active, setActive] = useState<number | null>(null)
    const last = GALLERY.items.length - 1

    return (
        <section id='gallery' aria-labelledby='gallery-title' className='relative overflow-hidden bg-secondary/60 py-24 sm:py-32'>
            <div className='mx-auto max-w-6xl px-5 sm:px-8'>
                <Reveal>
                    <SectionHeading
                        id='gallery-title'
                        title={GALLERY.title}
                        subtitle={GALLERY.subtitle}
                    />
                </Reveal>

                <ul className='mt-16 grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3'>
                    {GALLERY.items.map((item, index) => (
                        <li
                            key={item.photo.src}
                            className={cn(
                                'mx-auto w-full max-w-xs sm:max-w-none',
                                index === last && 'sm:col-span-2 sm:max-w-[calc(50%-1rem)] lg:col-span-1 lg:col-start-2 lg:max-w-none'
                            )}
                        >
                            <Reveal delay={(index % 3) * 100}>
                                <button
                                    type='button'
                                    onClick={() => setActive(index)}
                                    className={cn(
                                        'relative block w-full rounded-sm bg-white p-3 pb-5 text-left shadow-xl shadow-wine/10 transition duration-300 hover:rotate-0 hover:scale-[1.03] focus-visible:rotate-0 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/40 motion-reduce:transition-none',
                                        TILTS[index % TILTS.length]
                                    )}
                                >
                                    <span aria-hidden className='absolute -top-3 left-1/2 z-10 h-6 w-20 -translate-x-1/2 -rotate-3 bg-white/70 shadow-sm backdrop-blur-sm' />

                                    <MemoryPhoto photo={item.photo} ratio={1} />

                                    <span className='mt-4 block px-1 font-hand text-2xl leading-snug text-foreground'>
                                        {item.caption}
                                    </span>
                                </button>
                            </Reveal>
                        </li>
                    ))}
                </ul>
            </div>

            <Lightbox items={GALLERY.items} index={active} onChange={setActive} />
        </section>
    )
}

export default GallerySection
